import axios from 'axios';
import { nextTick } from 'vue';
import router from '@/router';
// STORES
import { useAuthStore } from '@/stores/AuthStore.js';

const axiosInstance = axios.create({
  baseURL: '/api/'
});

// Add a request interceptor
axiosInstance.interceptors.request.use(function (config) {
    // Do something before request is sent
    // console.log('config.url: ', config.url);
    if(useAuthStore().token &&
      Array.isArray(useAuthStore().token) &&
      useAuthStore().token.length
    ) {
      let newArr = useAuthStore().token;
      let selectedToken = newArr.pop();
      // console.log('selectedToken: ', selectedToken);

      config.headers = {
        'Authorization': `Bearer ${selectedToken}`
      };

      // console.log('useAuthStore().token before: ', useAuthStore().token);
      useAuthStore().$patch({
        token: newArr
      });

      // nextTick(() => {
      //   console.log('useAuthStore().token after: ', useAuthStore().token);
      // });


    } else if (Array.isArray(useAuthStore().token) &&
      useAuthStore().token.length < 1
    ) {
      console.log('No tokens!');
    } else {
      if(localStorage.getItem('token')) {
        config.headers = {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        };
      }
    }
    return config;

}, function (error) {
    console.error(error);
    // Do something with request error
    return Promise.reject(error);
},
  { synchronous: true, runWhen: () => (true)/* This function returns true */}
);

// Add a response interceptor
axiosInstance.interceptors.response.use(function(response) {
    // console.log(response)
    if (response.data.errormsg && response.data.logout) {
        axiosInstance.defaults.headers.common['Authorization'] = null;
        useAuthStore().signOut().then(() => {
            router.push({
                name: 'signin',
                replace: true
            })
            useAuthStore().$patch({
                error: 'Expired. Please sign in.'
            });
        });
    }
    if (response.data.errormsg && response.data.refresh) {
        console.error(response.data.errormsg);
        window.location = window.location;
        return;
    }
    if (response.data.access_token) {
      let newArr = (Array.isArray(useAuthStore().token)) ?
        useAuthStore().token : [];

        // console.log('response.data.access_token: ', response.data.access_token);

        newArr.push(response.data.access_token);
        nextTick(() => {
          useAuthStore().$patch({
            token: newArr
          });

          // just need one token locally stored for the case of page refresh
          localStorage.setItem('token', response.data.access_token);
        });
    }

    return response;
});

export default axiosInstance;
